import React from 'react';
import Select from './Select';

const SelectPerfil = ({
  inputRef,
  errors,
  className,
  label,
  tipo,
  ...rest
}) => {
  var perfil;
  if (tipo != 'adm') {
    perfil = [
      { valor: 'A', descricao: 'Administrador' },
      { valor: 'S', descricao: 'Supervisor' },
    ];
  } else {
    perfil = [{ valor: 'S', descricao: 'Supervisor' }];
  }
  const handleKeyDown = (e) => {
    let invalidChars = ['(', ')', ' ', '-'];
    const key = e.key;

    if (invalidChars.includes(key)) {
      e.preventDefault();
    }
  };
  return (
    <>
      {tipo != 'adm' ? (
        <Select
          className={className}
          options={[
            { label: 'Selecione', value: '' },
            ...perfil.map((item) => ({
              value: item.valor,
              label: item.descricao,
            })),
          ]}
          name="perfil"
          inputRef={inputRef}
          errors={errors}
          label={label}
          title="Selecione o Perfil do Terceiro"
          id="perfil"
          {...rest}
        />
      ) : (
        <Select
          className={className}
          options={[
            ...perfil.map((item) => ({
              value: item.valor,
              label: item.descricao,
            })),
          ]}
          name="perfil"
          inputRef={inputRef}
          errors={errors}
          label={label}
          id="perfil"
          {...rest}
        />
      )}
    </>
  );
};

export default SelectPerfil;
